<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <template v-slot:prepend>
        <v-toolbar>
          <img
            :style="{
              'max-width': $vuetify.breakpoint.smAndDown ? '100px' : '200px',
              'max-height': '48px',
            }"
            class="cursor-pointer mr-1"
            @click="$router.push('/')"
            aspect-ratio="1.0"
            :src="
              $operatorLogoUrl(domain)
            "
            :alt="domain"
          />
        </v-toolbar>
      </template>

      <DrawerList />
    </v-navigation-drawer>
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <UserAgent />
    </v-app-bar>

    <v-main>
      <ProgressLinear />
      <FeedbackDialog />
      <FeedbackSnack />
      <BetDialog />
      <TabsNavigation v-if="affiliateCpaType != '0'" />
      <FiltersGlobalWrap />
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import UserAgent from "@/components/agent/UserAgent";
import FeedbackDialog from "@/components/agent/Backoffice/feedback/FeedbackDialog";
import FeedbackSnack from "@/components/agent/Backoffice/feedback/FeedbackSnack";
import BetDialog from "@/components/agent/Backoffice/bet/BetDialog";
import DrawerList from "@/components/agent/Backoffice/drawer/DrawerList";
import ProgressLinear from "@/components/feedback/progress-linear.vue";
import FiltersGlobalWrap from "@/components/backoffice/filters_global/wrap";
import TabsNavigation from "../../components/TabsNavigation.vue";

export default {
  name: "BackofficeAgent",
  components: {
    DrawerList,
    UserAgent,
    FeedbackDialog,
    FeedbackSnack,
    BetDialog,
    // NEW
    ProgressLinear,
    FiltersGlobalWrap,
    TabsNavigation,
  },
  data: () => ({
    drawer: null,
    domain: "",
  }),
  mounted() {
    this.domain = this.$domain();
  },

  computed: {
    isAffilliate() {
      return this.$store.state.logged.data.is_afilliate;
    },

    affiliateCpaType() {
      return this.$store.state.affiliateCpaType;
    },
  },
};
</script>
